import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { getConfigFromHashParams } from '../../utils';
import { setConfig } from '../../actions';
import { Main } from './Main';

export const DEMO_PAGE_WIDTH = 1380;

const Root = styled.div`
  width: ${DEMO_PAGE_WIDTH}px;
  margin: 0 auto;
`;

export const DemoPage: FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setConfig(getConfigFromHashParams(window)));
  }, [dispatch]);

  return (
    <Root>
      <Main />
    </Root>
  );
};
